export default "__VITE_ASSET__CKG2j20c__"